import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=3e559ea0&"
import script from "./AddressBook.vue?vue&type=script&lang=js&"
export * from "./AddressBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports